import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatOptionSelectionChange } from '@angular/material/core';
import { Admin, BillDetail } from 'app/model';
import { WellKnownBillTypes } from 'app/model/enums/wellknown-bill-types';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable, combineLatest, map } from 'rxjs';

interface BillDetailRow {
  billId: number;
  billNumber: string;
  date: Date;
  billed: number;
  writtenOff?: number;
}

@Component({
  selector: 'time-entry-billed-details',
  templateUrl: './timeentry-billed-details.component.html',
})
export class TimeEntryBilledDetailsComponent implements OnChanges {
  @Input() adminId?: number;
  @Input() billDetails?: BillDetail[] = [];

  isBilled: boolean = false;
  billDetailRows: BillDetailRow[] = [];

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    this.calculateBillDetailRows();
    this.isBilled = this.billDetailRows.length > 0;
  }

  calculateBillDetailRows(): void {
    this.billDetailRows = (this.billDetails ?? []).map((bd) => {
      const isCreditNote = bd.bill ? bd.bill.billTypeId === WellKnownBillTypes.creditNote : !!bd.parentBillDetailId;
      return {
        billId: bd.billId,
        billNumber: (isCreditNote ? 'CR' : '') + bd.billId,
        date: bd.createdAt,
        billed: bd.billedTotal,
        writtenOff: bd.writeOffTotal,
      }
    });

    this.billDetailRows.sort((a, b) => a.billId - b.billId);
  }
}
